import FileDisplay from "@/components/ui/FileDisplay";
import { FileCollection } from "@/components/ui/FileDisplay/FileDisplayContent/FileCollection";
import { DetectedFileItem } from "@/components/ui/FileDisplay/utils";

interface FileContentDisplayProps {
  fileItems: DetectedFileItem[] | null;
  isPopoverOpen: boolean;
  setIsPopoverOpen: (open: boolean) => void;
  onAddFiles?: (fileUrls: string[]) => void;
  onSaveFile?: (newData: string, previousData: string) => void;
  onDeleteFile?: (index: number) => void;
  readOnly?: boolean;
  popoverPortalContainer?: HTMLElement | null;
}

const FileContentDisplay = ({
  fileItems,
  isPopoverOpen,
  setIsPopoverOpen,
  onAddFiles,
  onSaveFile,
  onDeleteFile,
  readOnly = false,
  popoverPortalContainer,
}: FileContentDisplayProps) => {
  if (!fileItems || fileItems.length === 0) {
    return null;
  }

  if (fileItems.length) {
    return (
      <div className="flex w-full items-center justify-center">
        <FileCollection
          isPopoverOpen={isPopoverOpen}
          setIsPopoverOpen={setIsPopoverOpen}
          fileCollectionCount={fileItems.length}
          onAddFiles={!readOnly ? onAddFiles : undefined}
          saveData={!readOnly ? onSaveFile : undefined}
          detectedFileValues={fileItems.map(item => item.data || "")}
          onDeleteFile={!readOnly ? onDeleteFile : undefined}
          showDeleteButtons={!readOnly}
          popoverPortalContainer={popoverPortalContainer}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center">
      <FileDisplay
        data={fileItems[0]?.data || ""}
        className="w-full"
        onDelete={!readOnly ? () => onDeleteFile?.(0) : undefined}
        showDeleteButton={!readOnly}
        detectedFile={fileItems[0]?.fileType || null}
      />
    </div>
  );
};

export default FileContentDisplay;
